<div class="info-tile-container">
    <app-info-tile
        [infoName]="'Current Averate Weight'"
        [infoValue]="bodyWeightStats.currentAvgWeight"
    >
    </app-info-tile>

    <app-info-tile
        [infoName]="'ODO'"
        [infoValue]="bodyWeightStats.odoWeight"
    >
    </app-info-tile>

    <app-info-tile [infoName]="'Growth'" [infoValue]="bodyWeightStats.growth">
    </app-info-tile>

    <app-info-tile
        [infoName]="'Target Achievements'"
        [infoValue]="bodyWeightStats.targetAchievements + '%'"
    >
    </app-info-tile>
</div>
